import React from "react";
import Context from "../../../Context";
import SuperSelect from "../../Misc/SuperSelect";
import EssenceReferenceShipEdit from "../../Essence/EssenceReferenceShipEdit";
import EssenceReference from "../../Essence/EssenceReference";
import EssenceReferenceCisternEdit from "../../Essence/EssenceReferenceCisternEdit";

export default class BunkerShipSelect extends React.Component {
  static contextType = Context;

  constructor(props) {
    super(props);
    this.state = {
      showCisterReference: false,
    };
  }

  onChange = (shipId) => {
    this.context.redirect(`/bunker/${shipId}/`);
  };

  onCisterReferenceOpen = () => {
    this.setState({ showCisterReference: true });
  };

  onCisterReferenceClose = () => {
    this.setState({ showCisterReference: false });
    if (this.props.onFinish) {
      this.props.onFinish();
    }
  };

  onSingleItem = (item) => {
    if (item.value && item.value !== this.props.shipId) {
      this.context.replace(`/bunker/${item.value}/`);
    }
  };

  render() {
    return (
      <>
        <EssenceReference
          essence="cistern"
          sort="sequence"
          title="Бункеры"
          showDescription
          editOnDblClick
          show={this.state.showCisterReference}
          onHide={this.onCisterReferenceClose}
          itemEditor={(itemEditorProps) => (
            <EssenceReferenceCisternEdit {...itemEditorProps} />
          )}
          extraFields={["shipname"]}
        />
        <SuperSelect
          defaultValue={this.props.shipId}
          onChange={(value) => this.onChange(value)}
          onSingleItem={this.onSingleItem}
          essence="ship"
          placeholder="Выберите судно..."
          nameField="name"
          idField="id"
          button={
            <div
              title="Настройка справочника судовых бункеров"
              className="btn btn-icon btn-white"
              onClick={this.onCisterReferenceOpen}
            >
              <i className="fa fa-cogs" />
            </div>
          }
          refBtnClass="btn-white"
          reference={{
            title: "Суда",
            essence: "ship",
            showDescription: true,
            showType: true,
            itemEditor: (itemEditorProps) => (
              <EssenceReferenceShipEdit {...itemEditorProps} />
            ),
          }}
        />
      </>
    );
  }
}
